import { Box, Stack, Table, TableContainer } from '@mui/material';
import { cpgMediaTypeData } from '@features/benchmarks';
import { TableSection } from './TableSection';
import { BENCHMARK_INTRO } from './constants';

const BenchmarksCPG = () => (
  <Box id="help_benchmarks_cpg" className="tab-pane active" padding={1}>
    <p>{BENCHMARK_INTRO}</p>

    <Stack direction="column" padding="1rem">
      <TableContainer>
        <Table>
          <TableSection nameLabel="Media Type" data={cpgMediaTypeData} />
        </Table>
      </TableContainer>
    </Stack>
  </Box>
);

export default BenchmarksCPG;
